import { host } from "config/api.config";
import { IndicatorRangeAlertConfig, IndicatorRangeAlertConfigInput } from "model/indicatorRangeAlertConfig.model";
import { useHTTPClient } from "services/httpClient.service";

const url = `${host}/alert-config`
const urlIndicatorRange = `${url}/indicator-range`

export function useGetIndicatorRangeAlertConfigsApi(){
    const {data, loading, error, get} = useHTTPClient<IndicatorRangeAlertConfig[]>(urlIndicatorRange)

    async function getApi(filter:{companyId: string, indicatorIds: string[]}) {
        return get({params: filter})
    }

    return {
        loading,
        error,
        get: getApi,
        data
    }
}

export function useGetIndicatorRangeAlertConfigApi(){
    const {data, loading, error, get} = useHTTPClient<IndicatorRangeAlertConfig>(urlIndicatorRange)

    async function getApi(id: string) {
        return get({_url: `${urlIndicatorRange}/${id}`})
    }

    return {
        loading,
        error,
        get: getApi,
        data
    }
}

export function useDeleteIndicatorRangeAlertConfigApi(){
    const {data, loading, error, _delete} = useHTTPClient<IndicatorRangeAlertConfig[]>(urlIndicatorRange)

    async function deleteApi(id: string) {
        return _delete({_url: `${urlIndicatorRange}/${id}`})
    }

    return {
        loading,
        error,
        delete: deleteApi,
        data
    }
}

export function useSaveNewIndicatorRangeAlertConfigApi(){
    const {data, loading, error, post} = useHTTPClient<IndicatorRangeAlertConfig[]>(urlIndicatorRange)

    async function postApi(config: IndicatorRangeAlertConfigInput) {
        return post({data: config})
    }

    return {
        loading,
        error,
        saveNew: postApi,
        data
    }
}

export function useUpdateIndicatorRangeAlertConfigApi(){
    const {data, loading, error, put} = useHTTPClient<IndicatorRangeAlertConfig[]>(urlIndicatorRange)

    async function putApi(id: string, config: Partial<IndicatorRangeAlertConfigInput>) {
        return put({data: config, _url: `${urlIndicatorRange}/${id}`})
    }

    return {
        loading,
        error,
        update: putApi,
        data
    }
}